import classNames from "classnames";
import React from "react";

interface ShortcutBarProps<T extends string> {
  options: {
    label: string;
    value: T;
    href: string;
    count?: number;
    isWarning?: boolean;
  }[];
  value: T;
  onChange: (value: T) => void;
}

export const ShortcutBar = <T extends string>({ options, value, onChange }: ShortcutBarProps<T>) =>
  <div className="flex gap shortcut-bar">
    {options.map(option =>
      <a
        key={option.value}
        href={option.href}
        className={classNames("shortcut-bar-button", { selected: option.value === value, warning: option.isWarning })}
        onClick={e => {
          // Modifier clicks keep the browser behavior, like opening the tab in a new window
          if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
          e.preventDefault();
          onChange(option.value);
        }}
      >
        {option.label}
        {option.count > 0 && <span className={classNames({ "text-light": option.value !== value })}>{option.count}</span>}
      </a>
    )}
  </div>;
